import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/dot.tsx
var Dot = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("circle", {
		cx: "12",
		cy: "12",
		r: "4",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("circle", {
		cx: "12",
		cy: "12",
		r: "4",
		fill: "currentColor"
	})
});
//#endregion
export { Dot };
